import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import OneLineTextField from '../CustomizedUIs/CustomTextFiled';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';

const useStyles = makeStyles({
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '11px',
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
});

function StartInActiveBrowser() {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [openPoper, setOpenPopper] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { url, enableMetaData } = nodeSelected.applicationData.nodeApplication.startInactiveBrowser;

    const onChangeValue = prop => (value) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                startInactiveBrowser: {
                    ...nodeSelected.applicationData.nodeApplication.startInactiveBrowser,
                    [prop]: value
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    return (
        <Box>
            <Box mt={3.5} >
                <OneLineTextField
                    disabled={!isEditing}
                    id="filled-basic"
                    label={translate(`pos.categories.url`)}
                    value={url}
                    onChange={(event) => onChangeValue('url')(event.target.value)}
                    style={{ width: 500 }}
                    endDom={<CustomPoper
                        color={'#e5f1f8'}
                        fontSize={'11px'}
                        open={openPoper}
                        handleClick={() => setOpenPopper(true)}
                        handleClose={() => setOpenPopper(false)}
                        title={translate(`pos.common.url`)}
                        content={translate(`pos.common.contentURL`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box style={{ marginTop: 20 }} >
                <Box width={200} display='flex' borderRadius={4} bgcolor='background.paper' my={1} px={1} alignItems='center'>
                    <Box flexGrow={1}>
                        <Typography className={classes.TitleSwitch} >{translate('resources.infoPage.startInactiveBrowser.enable_metadata').toUpperCase()}</Typography>
                    </Box>
                    <GreenSwitch
                        disabled={!isEditing}
                        checked={enableMetaData}
                        onChange={(event) => onChangeValue('enableMetaData')(event.target.checked)}
                        size='small'
                    />
                </Box>
            </Box>
        </Box>

    )
}

export default StartInActiveBrowser;
